<template>
  <v-list-item>
    <v-list-item-icon>
      <v-icon :color="iconColor">
        {{ icon }}
      </v-icon>
    </v-list-item-icon>
    <v-list-item-content>
      <v-list-item-title class="d-flex align-center">
        <span
          class="font-weight-bold"
          v-text="label"
        />
        <span class="pr-1">:</span>
        <span
          class="word-break"
          :style="contentStyle"
          v-text="content"
        />
      </v-list-item-title>
    </v-list-item-content>
    <v-list-item-action>
      <slot name="action" />
    </v-list-item-action>
  </v-list-item>
</template>

<script>
export default {
  name: 'BaseListItemIconAndAction',
  props: {
    icon: {
      type: String,
      required: true,
      note: 'The icon name',
    },
    iconColor: {
      type: String,
      default: '',
      note: 'The icon color',
    },
    label: {
      type: String,
      required: true,
      note: 'The item label',
    },
    content: {
      type: [String, Number, Object],
      required: true,
      note: 'The item content',
    },
    contentStyle: {
      type: String,
      default: '',
      note: 'The datum custom style',
    },
  },
};
</script>

<style scoped>
.word-break {
  white-space: normal;
  word-break: break-all;
}
</style>
